<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <div class="float-right mb-1">
        <router-link tag="button" :to="{ name: 'EXSBRefundCreate' }" class="btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
      </div>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <RefundFiltering
            @getPage="getPage($event)"
            ref="refundFiltering"></RefundFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <div v-if="isLoading">
        <Loader></Loader>
      </div>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.exsbrefund.list.noRefunds') }}
      </div>
      <div v-else>
        <table class="table table-sm table-responsive-md table-striped table-hover">
          <thead>
          <tr>
            <th>{{ $t('views.exsbrefund.list.paymentDate') }}</th>
            <th>{{ $t('views.exsbrefund.list.idClient') }}</th>
            <th>{{ $t('views.excmnotificationmessage.form.description') }}</th>
            <th>{{ $t('views.exsbrefund.form.bankPaymentDescription') }}</th>
            <th>{{ $t('views.exsbpaymentsmade.edit.payer') }}</th>
            <th>{{ $t('views.exsbbankpackages.show.package')}}</th>
            <th>{{ $t('views.exsbrefund.list.value') }}</th>
            <th style="width: 10%;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item['@id']">
            <td>{{ $moment(item.paymentDate).format('YYYY-MM-DD') }}</td>
            <td>
              <router-link v-if="item.idUserData && item.idClient.isCompany === 0" :to="{name: 'UserDataShow', params: { id: item.idClient['@id'] }}">
                {{ item.idClient.name }} {{ item.idClient.surname }}
              </router-link>
              <router-link v-else-if="item.idClient" :to="{name: 'FirmShow', params: { id: item.idClient['@id'] }}">
                {{ item.idClient.firmname1 === '' ? item.idClient.fullName : item.idClient.firmname1 }}
              </router-link>
            </td>
            <td>{{ item.description }}</td>
            <td>
              <span v-if="item.idBankPayment">{{ item.idBankPayment.description }}</span>
            </td>
            <td>
              <span v-if="item.idBankPayment">{{ item.idBankPayment.payer }}</span>
            </td>
            <td>
              <div v-if="item.idBankPayment" class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-search fa-lg" :to="{ name: 'EXSBBankPackagesShow', params: { id: item.idBankPayment.idBankPackages } }"></router-link>
              </div>
              <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
            </td>
            <td>{{ item.value }} {{$t('currency')}}</td>
            <td>
              <div class="btn-group">
                <router-link tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{ name: 'EXSBRefundUpdate', params: { id: item['@id'] }}"></router-link>
                <b-button @click="deleteSingle(item['@id'])" class="btn btn-link fa fa-trash fa-lg"></b-button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="view">
        <Pagination
          :view="view"
          :totalItems="totalItems"
          @getPage="getPage($event)"
          @getPageNumber="setCurrentPage($event.page)"
        ></Pagination>
      </div>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'
import remove from '@/utils/remove'
import RefundFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbrefund/components/RefundFiltering.vue'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'List',
  components: {
    RefundFiltering,
    BaseTableWrapper,
    Pagination,
    Loader
  },
  data () {
    return {
      searchParams: this.$store.state.filters.refundFilter
    }
  },
  computed: {
    ...mapGetters({
      error: 'exsbrefund/list/error',
      items: 'exsbrefund/list/items',
      isLoading: 'exsbrefund/list/isLoading',
      view: 'exsbrefund/list/view',
      totalItems: 'exsbrefund/list/totalItems'
    }),
    filterStatus () {
      return JSON.stringify(this.$store.state.filters.refundFilter) !== JSON.stringify(this.$store.state.filters.refundFilterReference)
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBRefundList')
    if (Object.keys(this.$store.state.filters.refundFilter).length === 0) {
      this.$store.state.filters.refundFilter = JSON.parse(JSON.stringify(this.$store.state.filters.refundFilterReference))
    }
  },
  created () {
    let params = Object.assign({ '_page': this.$store.state.filters.refundFilterCurrentPage }, this.searchParams)
    if (params.bankPayment === 1) {
      params['idBankPayment[exists]'] = true
    } else if (params.bankPayment === 2) {
      params['idBankPayment[exists]'] = false
    }
    params.bankPayment = undefined
    if (params.invoice === 1) {
      params['idEXSBInvoice[exists]'] = true
    } else if (params.invoice === 2) {
      params['idEXSBInvoice[exists]'] = false
    }
    params.invoice = undefined
    let url = addParamsToQuery('e_x_s_b_refunds', params)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'exsbrefund/list/getItems'
    }),
    setCurrentPage (page) {
      this.$store.state.filters.refundFilterCurrentPage = page
    },
    clearFilters () {
      if (this.$refs.refundFiltering) {
        this.$refs.refundFiltering.clearFilters()
      }
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getPage(this.view)
      })
    }
  }
}
</script>

<style scoped>

</style>
